import { cn } from '@/styles/utils';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import Image from 'next/image';
import * as React from 'react';

interface CheckboxProps
  extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  bgColor?: string | undefined;
  checkImageSrc?: string;
}

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(
  (
    {
      className,
      bgColor,
      checkImageSrc = '/images/check-default.svg',
      ...props
    },
    ref,
  ) => (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        'peer h-4 w-4 shrink-0 rounded-sm border border-[#c6cbd3] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-none data-[state=checked]:bg-(--primary-400) data-[state=checked]:text-primary-foreground',
        className,
      )}
      style={{
        backgroundColor: props.checked ? bgColor : 'transparent',
      }}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn('flex items-center justify-center text-current')}
      >
        <Image
          className="w-fit h-fit"
          src={checkImageSrc}
          alt="check"
          width={18}
          height={18}
        />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  ),
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
